module.exports = __webpack_public_path__ + "static/media/realtalk_sd_syun43051798f59b7ce9e4781066354f7dd6.webp";